import { render, staticRenderFns } from "./IconBanSolid.vue?vue&type=template&id=22548848"
import script from "./IconBanSolid.vue?vue&type=script&lang=js"
export * from "./IconBanSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports